import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../components/Modal/CustomModal';

const PluginWarnModal = (props) => {
    const { t } = useTranslation();
    return (

        <CustomModal
            title={t('warning')}
            size='lg'
            buttonConfirm='add'
            classNameBody="pt-2"
            {...props}
            cancelButton={false}
            confirmButton={false}
        >
            <p className='paragraph_title mt-3'>{t('plugin_warn')}</p>
        </CustomModal>
    );
};

export default PluginWarnModal;
